import { FC, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { store } from "store";
import { AppInputParsedData } from "./App.types";
import { DEFAULT_LANG } from "./constants/common.constants";
import App from "./App";
// import { PaymentsProvider } from "./components/Local/Payments/context/Payments.context";
import { useForceRender } from "./hook/useForceRender";
import { i18n } from "./localization/i18n";
import "./assets/styles/index.scss";

const AppExport: FC<{ inputData: AppInputParsedData }> = ({ inputData }) => {
  const { forceRender } = useForceRender();
  const { options } = inputData;

  const changeLanguage = () => {
    if (options.lang) {
      const language = options.lang.replace(/[^a-za-яё]/gi, "");
      i18n.changeLanguage(language === "" ? DEFAULT_LANG : language, () => forceRender());
    } else {
      i18n.changeLanguage(DEFAULT_LANG, () => forceRender());
    }
  };

  useEffect(() => changeLanguage(), [options.lang]);

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        {/* <PaymentsProvider platformId={options?.platformId} authTokenUrl={options.authTokenUrl}> */}
        <App platformId={options?.platformId} authTokenUrl={options.authTokenUrl} />
        {/* </PaymentsProvider> */}
      </I18nextProvider>
    </Provider>
  );
};

export default AppExport;
